var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_289_29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.375 21.375V4.5C3.375 4.20163 3.49353 3.91548 3.7045 3.7045C3.91548 3.49353 4.20163 3.375 4.5 3.375H14.625C14.9234 3.375 15.2095 3.49353 15.4205 3.7045C15.6315 3.91548 15.75 4.20163 15.75 4.5V13.5H18C18.5967 13.5 19.169 13.7371 19.591 14.159C20.0129 14.581 20.25 15.1533 20.25 15.75V20.25C20.25 20.5484 20.3685 20.8345 20.5795 21.0455C20.7905 21.2565 21.0766 21.375 21.375 21.375C21.6734 21.375 21.9595 21.2565 22.1705 21.0455C22.3815 20.8345 22.5 20.5484 22.5 20.25V12.375H20.25C19.9516 12.375 19.6655 12.2565 19.4545 12.0455C19.2435 11.8345 19.125 11.5484 19.125 11.25V7.21575L17.2609 5.35162L18.8516 3.76087L24.4204 9.32963C24.525 9.43396 24.608 9.55793 24.6645 9.69443C24.7211 9.83092 24.7502 9.97725 24.75 10.125V20.25C24.75 21.1451 24.3944 22.0036 23.7615 22.6365C23.1286 23.2694 22.2701 23.625 21.375 23.625C20.4799 23.625 19.6215 23.2694 18.9885 22.6365C18.3556 22.0036 18 21.1451 18 20.25V15.75H15.75V21.375H16.875V23.625H2.25V21.375H3.375ZM5.625 5.625V12.375H13.5V5.625H5.625Z",
    fill: "#FDE16A"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPump);
export default __webpack_public_path__ + "static/media/pump.ffca5f881d6e3177b5a1aa76120eaf6c.svg";
export { ForwardRef as ReactComponent };